import { DrawingType, ScribbleUpdateDetails } from '../constants';
import { getCanvasPointerPosition } from '../utils';
import { getNewId } from 'utils/Global';
import TransformPoints from 'components/plateviewer/well/TransformPoints';

let scribbleDrawing: ScribbleUpdateDetails = null;
let isDrawingFirstClick: boolean = false;

export const useScribbleCreateHandlers = (
  drawingColor: string,
  tpObject: TransformPoints,
) => {
  const onMouseDown: (e) => { drawing: ScribbleUpdateDetails; type: DrawingType } = (
    e,
  ) => {
    const { x, y } = getCanvasPointerPosition(e);
    const [dbX, dbY] = tpObject.FromCanvasToDb(x, y);
    scribbleDrawing = {
      id: getNewId(),
      x,
      y,
      dbX,
      dbY,
      points: [],
      color: drawingColor,
      zIndex: 0,
      isNewDrawing: true,
    };
    isDrawingFirstClick = true;
    return null;
  };

  const onMouseMove: (e) => {
    drawing: ScribbleUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    const { x, y } = getCanvasPointerPosition(e);
    scribbleDrawing = {
      ...scribbleDrawing,
      points: [
        ...scribbleDrawing.points,
        ...[x - scribbleDrawing.x, y - scribbleDrawing.y],
      ],
    };
    const drawingData = {
      drawing: scribbleDrawing,
      type: DrawingType.Scribble,
      isDrawingFirstClick,
    };
    isDrawingFirstClick = false;
    return drawingData;
  };

  const onMouseUp: (e) => { drawing: ScribbleUpdateDetails; type: DrawingType } = (e) => {
    if (!isDrawingFirstClick) {
      scribbleDrawing = {
        ...scribbleDrawing,
        isNewDrawing: false,
      };
      return { drawing: scribbleDrawing, type: DrawingType.Scribble };
    }
    isDrawingFirstClick = false;
    return null;
  };

  return { onMouseDown, onMouseMove, onMouseUp };
};
